"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("../../colors"));

require("../TextInput/TextInput.css");

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var MaskedInput = _react["default"].forwardRef(function (props, ref) {
  var autoFocus = props.autoFocus,
      label = props.label,
      helperText = props.helperText,
      placeholder = props.placeholder,
      hasError = props.hasError,
      errorText = props.errorText,
      disabled = props.disabled,
      _onChange = props.onChange,
      value = props.value,
      type = props.type,
      mask = props.mask,
      maskChar = props.maskChar,
      maskType = props.maskType;

  var _useState = (0, _react.useState)(autoFocus),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocus = _useState2[1];

  var classes = (0, _classnames["default"])({
    'kt-text-input': true
  });

  var maskValue = function (maskType) {
    switch (maskType) {
      case 'phone':
        return '(999) 999 - 9999';

      case 'ssn':
        return '999 99 9999';

      case 'cc':
        return '9999 9999 9999 9999';

      case 'pin':
        return '9999';

      case 'ein':
        return '99-9999999';

      default:
        return null;
    }
  }(maskType);

  return _react["default"].createElement("div", null, _react["default"].createElement("div", {
    style: {
      marginBottom: 8
    }
  }, label && _react["default"].createElement("span", {
    className: "kt-text-input-label",
    "aria-label": label,
    style: {
      color: hasError && _colors["default"].danger,
      opacity: disabled && 0.5
    }
  }, label), _react["default"].createElement(_core.Collapse, {
    "in": helperText && isFocused
  }, _react["default"].createElement("span", {
    className: "kt-text-input-helper-text",
    "aria-label": helperText,
    style: {
      color: hasError && _colors["default"].danger,
      opacity: disabled && 0.5
    }
  }, helperText))), _react["default"].createElement(_reactInputMask["default"], {
    ref: ref,
    autoFocus: autoFocus,
    className: classes,
    placeholder: placeholder,
    disabled: disabled,
    onFocus: function onFocus() {
      return setFocus(true);
    },
    onBlur: function onBlur() {
      return setFocus(false);
    },
    onChange: function onChange(event) {
      return _onChange(event);
    },
    required: hasError,
    value: value,
    type: type,
    mask: maskValue || mask,
    maskChar: maskChar || null
  }), hasError && errorText && _react["default"].createElement("span", {
    className: "kt-text-input-error-text",
    "aria-label": errorText
  }, errorText));
});

MaskedInput.propTypes = {
  autoFocus: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  hasError: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string,
  mask: _propTypes["default"].string,
  maskChar: _propTypes["default"].string,
  maskType: _propTypes["default"].oneOf(['phone', 'ssn', 'cc', 'pin', 'ein'])
};
MaskedInput.defaultProps = {
  autoFocus: false,
  hasError: false,
  disabled: false,
  onChange: function onChange() {},
  value: ''
};
var _default = MaskedInput;
exports["default"] = _default;